// This file is to be used for the modal that warns the user that they are about to be linked to an external website

$(document).ready(function () {
    var openedSite = false;
    popUpExternal = function () {

        if (this.checkModalPreferenceCookie() != 1) {
            $('#externalContent').modal({
                onClose: function () {
                    if (!openedSite) {
                        document.cookie = "HideModal=0";
                        $('#externalSiteCheckbox').prop('checked', false);
                    }
                    openedSite = false;
                }
            });
        } else {
            var url = $(".externalModalLink").attr('href');
            var newWindow = window.open(url, '_blank');
            newWindow.focus();
        }
    };

	$('.externalModalCancel').click(function () {
	    $.modal.close();
	});

	$('.externalModalButton').click(function () {
	    openedSite = true;
	    $.modal.close();
	});

	$('.externalModalLink').click(function () {
	    openedSite = true;
	    $.modal.close();
	});

	$('#externalSiteCheckbox').click(function () {
		if ($('#externalSiteCheckbox:checked').val() === 'on') {
			document.cookie = "HideModal=1";
		}
		else {
			document.cookie = "HideModal=0";
		}
	});

	checkModalPreferenceCookie = function () {
	    var search = "HideModal=";
	    var cookieVal = "";

	    if (document.cookie.length > 0) {
	        var offset = document.cookie.indexOf(search);

	        if (offset !== -1) {
	            offset += search.length;
	            var end = document.cookie.indexOf(";", offset);

	            if (end === -1) {
	                end = document.cookie.length;
	            }

	            cookieVal = unescape(document.cookie.substring(offset, end));
	        }
	    }
	    return cookieVal;
	};
});
